"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnIntegSt = void 0;
const base_1 = require("./base");
const st_1 = require("../services/st");
/**
 * AdWords
 */
class AnIntegSt extends base_1.AnIntegBase {
    static getSiteName() {
        return "The Menlo House";
    }
    static getClubProductName() {
        return "The Menlo House: Club Package";
    }
    static getClubProductUrl() {
        return "https://www.themenlohouse.com/club";
    }
    static isLoaded() {
        return st_1.AnServSt.isLoaded();
    }
    static sendInit(siteCategory, userId, email, coupon) {
        st_1.AnServSt.sendInit(this.getPixelId(siteCategory), null, null, null);
        return true;
    }
    static sendPage(siteCategory, userId, email) {
        if (userId !== null && email !== null) {
            st_1.AnServSt.sendIdentify(this.getPixelId(siteCategory), userId, email);
        }
        st_1.AnServSt.sendPage(this.getPixelId(siteCategory), [this.getSiteName()]);
        return true;
    }
    static sendTrackClubAccountCreate(siteCategory, userId, email) {
        st_1.AnServSt.sendAddToCart(this.getPixelId(siteCategory), email, this.getClubProductUrl(), this.getClubProductName(), 
        // For now just specify $1.00
        100);
        return true;
    }
    static sendTrackClubAccountCreateLegacy(siteCategory, userId, email) {
        this.sendTrackClubAccountCreate(siteCategory, userId, email);
        return true;
    }
    static sendTrackClubThankyou(siteCategory, userId, email, price, style, color, coupon) {
        st_1.AnServSt.sendPurchase(this.getPixelId(siteCategory), email, this.getClubProductUrl(), this.getClubProductName(), 
        // For now just specify $1.00
        100);
        return true;
    }
    static sendTrackClubThankyouLegacy(siteCategory, userId, email, price, style, color, coupon) {
        return this.sendTrackClubThankyou(siteCategory, userId, email, price, style, color, coupon);
    }
}
exports.AnIntegSt = AnIntegSt;
AnIntegSt.shouldSendEveryPage = true;
AnIntegSt.shouldSendTrackClubAccountCreate = true;
AnIntegSt.shouldSendTrackClubAccountCreateLegacy = true;
AnIntegSt.shouldSendTrackClubThankyou = true;
AnIntegSt.shouldSendTrackClubThankyouLegacy = true;
AnIntegSt.pixelId = {
    prod: {
        defaultId: "0a99f30603d518968182d43349edb115",
        ecomm: null,
        club: null,
    },
    dev: {
        defaultId: "0a99f30603d518968182d43349edb115",
        ecomm: null,
        club: null,
    },
};
